var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    !_vm.formSubmitted
      ? _c("section", [
          _c(
            "div",
            {
              staticClass:
                "container--form relative padding-top-2 space-bottom-2",
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "col xs-12 lg-6" }, [
                  _c("div", { staticStyle: { display: "block" } }),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      ref: "nationwideForm",
                      staticClass: "flex center-xs start-md flex-wrap",
                      attrs: { id: "nationwide-form", name: "nationwideform" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submitForm.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex center-xs full-width" }, [
                        _c(
                          "div",
                          { staticClass: "flex mobile-column full-width" },
                          [
                            _c("div", { staticClass: "input-box start-xs" }, [
                              _vm._m(3),
                              _vm._v(" "),
                              _c("div", { staticClass: "relative" }, [
                                _vm.displayErrors && _vm.$v.firstname.$invalid
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.firstname.$model,
                                          expression: "$v.firstname.$model",
                                        },
                                      ],
                                      staticClass: "error",
                                      attrs: {
                                        type: "text",
                                        id: "firstname",
                                        placeholder: "Jane",
                                        name: "firstname",
                                      },
                                      domProps: {
                                        value: _vm.$v.firstname.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.firstname,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.firstname.$model,
                                          expression: "$v.firstname.$model",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                        id: "firstname",
                                        placeholder: "Jane",
                                        name: "firstname",
                                      },
                                      domProps: {
                                        value: _vm.$v.firstname.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.firstname,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                _vm._v(" "),
                                !_vm.$v.firstname.$invalid
                                  ? _c("div", { staticClass: "valid-check" })
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-box start-xs" }, [
                              _vm._m(4),
                              _vm._v(" "),
                              _c("div", { staticClass: "relative" }, [
                                _vm.displayErrors && _vm.$v.lastname.$invalid
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.lastname.$model,
                                          expression: "$v.lastname.$model",
                                        },
                                      ],
                                      staticClass: "error",
                                      attrs: {
                                        type: "text",
                                        id: "lastname",
                                        placeholder: "Doe",
                                        name: "lastname",
                                      },
                                      domProps: {
                                        value: _vm.$v.lastname.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.lastname,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.lastname.$model,
                                          expression: "$v.lastname.$model",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                        id: "lastname",
                                        placeholder: "Doe",
                                        name: "lastname",
                                      },
                                      domProps: {
                                        value: _vm.$v.lastname.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.lastname,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                _vm._v(" "),
                                !_vm.$v.lastname.$invalid
                                  ? _c("div", { staticClass: "valid-check" })
                                  : _vm._e(),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex center-xs full-width" }, [
                        _c(
                          "div",
                          { staticClass: "flex mobile-column full-width" },
                          [
                            _c("div", { staticClass: "input-box start-xs" }, [
                              _vm._m(5),
                              _vm._v(" "),
                              _c("div", { staticClass: "relative" }, [
                                _vm.displayErrors && _vm.$v.email.$invalid
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.email.$model,
                                          expression: "$v.email.$model",
                                        },
                                      ],
                                      staticClass: "error",
                                      attrs: {
                                        type: "email",
                                        id: "email",
                                        placeholder: "example@company.com",
                                        name: "email",
                                      },
                                      domProps: { value: _vm.$v.email.$model },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.email,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.email.$model,
                                          expression: "$v.email.$model",
                                        },
                                      ],
                                      attrs: {
                                        type: "email",
                                        id: "email",
                                        placeholder: "example@company.com",
                                        name: "email",
                                      },
                                      domProps: { value: _vm.$v.email.$model },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.email,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                _vm._v(" "),
                                !_vm.$v.email.$invalid
                                  ? _c("div", { staticClass: "valid-check" })
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-box start-xs" }, [
                              _vm._m(6),
                              _vm._v(" "),
                              _c("div", { staticClass: "relative" }, [
                                _vm.displayErrors && _vm.$v.company.$invalid
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.company.$model,
                                          expression: "$v.company.$model",
                                        },
                                      ],
                                      staticClass: "error",
                                      attrs: {
                                        type: "text",
                                        id: "company",
                                        placeholder: "ABC Inc",
                                        name: "company",
                                      },
                                      domProps: {
                                        value: _vm.$v.company.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.company,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.company.$model,
                                          expression: "$v.company.$model",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                        id: "company",
                                        placeholder: "ABC Inc",
                                        name: "company",
                                      },
                                      domProps: {
                                        value: _vm.$v.company.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.company,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                _vm._v(" "),
                                !_vm.$v.company.$invalid
                                  ? _c("div", { staticClass: "valid-check" })
                                  : _vm._e(),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex center-xs full-width" }, [
                        _c(
                          "div",
                          { staticClass: "flex mobile-column full-width" },
                          [
                            _c("div", { staticClass: "input-box start-xs" }, [
                              _vm._m(7),
                              _vm._v(" "),
                              _c("div", { staticClass: "relative" }, [
                                _vm.displayErrors && _vm.$v.phone.$invalid
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.phone.$model,
                                          expression: "$v.phone.$model",
                                        },
                                      ],
                                      staticClass: "error",
                                      attrs: {
                                        type: "tel",
                                        id: "phone",
                                        placeholder: "(000) - 000 0000",
                                        name: "phone",
                                      },
                                      domProps: { value: _vm.$v.phone.$model },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.phone,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.phone.$model,
                                          expression: "$v.phone.$model",
                                        },
                                      ],
                                      attrs: {
                                        type: "tel",
                                        id: "phone",
                                        placeholder: "(000) - 000 0000",
                                        name: "phone",
                                      },
                                      domProps: { value: _vm.$v.phone.$model },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.phone,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                _vm._v(" "),
                                !_vm.$v.phone.$invalid
                                  ? _c("div", { staticClass: "valid-check" })
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-box start-xs" }, [
                              _vm._m(8),
                              _vm._v(" "),
                              _c("div", { staticClass: "relative" }, [
                                _vm.displayErrors && _vm.$v.dotNumber.$invalid
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.dotNumber.$model,
                                          expression: "$v.dotNumber.$model",
                                        },
                                      ],
                                      staticClass: "error",
                                      attrs: {
                                        type: "tel",
                                        id: "phone",
                                        placeholder: "000 000 0000",
                                        name: "dotNumber",
                                      },
                                      domProps: {
                                        value: _vm.$v.dotNumber.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.dotNumber,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.dotNumber.$model,
                                          expression: "$v.dotNumber.$model",
                                        },
                                      ],
                                      attrs: {
                                        type: "tel",
                                        id: "dotNumber",
                                        placeholder: "000 000 0000",
                                        name: "phone",
                                      },
                                      domProps: {
                                        value: _vm.$v.dotNumber.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.dotNumber,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                _vm._v(" "),
                                !_vm.$v.dotNumber.$invalid
                                  ? _c("div", { staticClass: "valid-check" })
                                  : _vm._e(),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex center-xs full-width" }, [
                        _c(
                          "div",
                          { staticClass: "flex mobile-column full-width" },
                          [
                            _c("div", { staticClass: "input-box start-xs" }, [
                              _vm._m(9),
                              _vm._v(" "),
                              _c("div", { staticClass: "relative" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.street,
                                      expression: "street",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    id: "street",
                                    name: "street",
                                    placeholder: "123 Main St",
                                  },
                                  domProps: { value: _vm.street },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.street = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-box start-xs" }, [
                              _vm._m(10),
                              _vm._v(" "),
                              _c("div", { staticClass: "relative" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.city,
                                      expression: "city",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    id: "city",
                                    name: "city",
                                    placeholder: "City",
                                  },
                                  domProps: { value: _vm.city },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.city = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex center-xs full-width" }, [
                        _c(
                          "div",
                          { staticClass: "flex mobile-column full-width" },
                          [
                            _c("div", { staticClass: "input-box start-xs" }, [
                              _vm._m(11),
                              _vm._v(" "),
                              _c("div", { staticClass: "relative" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.state,
                                      expression: "state",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    id: "state",
                                    name: "state",
                                    placeholder: "State",
                                  },
                                  domProps: { value: _vm.state },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.state = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-box start-xs" }, [
                              _vm._m(12),
                              _vm._v(" "),
                              _c("div", { staticClass: "relative" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.zip,
                                      expression: "zip",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    id: "zip",
                                    name: "zip",
                                    placeholder: "11111",
                                  },
                                  domProps: { value: _vm.zip },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.zip = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._m(13),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex center-xs full-width" }, [
                        _c(
                          "div",
                          { staticClass: "flex mobile-column full-width" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-box-wrapper full-width start-xs",
                              },
                              [
                                _vm._m(14),
                                _vm._v(" "),
                                _vm.displayErrors && _vm.$v.vins.$invalid
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.vins.$model,
                                          expression: "$v.vins.$model",
                                        },
                                      ],
                                      staticClass: "text-box error",
                                      attrs: {
                                        cols: "30",
                                        rows: "10",
                                        placeholder:
                                          "Please enter one VIN per line (max 10)",
                                      },
                                      domProps: { value: _vm.$v.vins.$model },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.vins,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.vins.$model,
                                          expression: "$v.vins.$model",
                                        },
                                      ],
                                      staticClass: "text-box",
                                      attrs: {
                                        cols: "30",
                                        rows: "10",
                                        placeholder:
                                          "Please enter one VIN per line (max 10)",
                                      },
                                      domProps: { value: _vm.$v.vins.$model },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.vins,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                _vm._v(" "),
                                _vm.vinList.length > 10
                                  ? _c("p", { staticClass: "red-text" }, [
                                      _vm._v(
                                        "Cannot enter more than 10 vehicle identification numbers"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex vertical-align full-width space-top-1 space-bottom-1",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex start-xs full-width align-center",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.$v.dashCamInstallCheck.$model,
                                    expression: "$v.dashCamInstallCheck.$model",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "dash-cam-check",
                                  name: "dash-cam-check",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.$v.dashCamInstallCheck.$model
                                  )
                                    ? _vm._i(
                                        _vm.$v.dashCamInstallCheck.$model,
                                        null
                                      ) > -1
                                    : _vm.$v.dashCamInstallCheck.$model,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.$v.dashCamInstallCheck.$model,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.$v.dashCamInstallCheck,
                                            "$model",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.$v.dashCamInstallCheck,
                                            "$model",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.$v.dashCamInstallCheck,
                                        "$model",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "dash-cam-check" } },
                                [
                                  _vm._v(
                                    "Check here confirming you will install the dash cam within 30 days of receiving it.\n                                  "
                                  ),
                                  _vm.displayErrors &&
                                  _vm.$v.dashCamInstallCheck.$invalid
                                    ? _c("div", { staticClass: "required" }, [
                                        _vm._v(" * Required Field"),
                                      ])
                                    : _c("div", { staticClass: "required" }, [
                                        _vm._v(" *"),
                                      ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex center-xs" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex start-xs vertical-align submit-box",
                          },
                          [
                            _vm._m(15),
                            _vm._v(" "),
                            _c("div", { staticClass: "center-xs start-lg" }, [
                              _c("input", {
                                staticClass: "form-button",
                                attrs: { type: "button", value: "Submit" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.testSubmit.apply(null, arguments)
                                  },
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ])
      : _c("section", [_vm._m(16)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "section",
      { staticClass: "nationwide--header flex align-center end-xs" },
      [
        _c("div", { staticClass: "full-width" }, [
          _c("div", { staticClass: "center-xs" }, [
            _c("div", { staticClass: "flex center-xs header-logos" }, [
              _c("a", { attrs: { href: "/" } }, [
                _c("img", {
                  staticClass: "samsara-logo-white",
                  attrs: {
                    src: "https://d9ylfbta65t3x.cloudfront.net/img/brand/samsara-logo-white-small.svg",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "white-vertical-divider" }),
              _vm._v(" "),
              _c("a", { attrs: { href: "/" } }, [
                _c("img", {
                  staticClass: "nationwide-logo-white",
                  attrs: {
                    src: "https://images.ctfassets.net/bx9krvy0u3sx/4pu4M8NWIAqhk3Ng91CEcV/a2322ef6bcfe45a3c93cd3baa1d14049/nationwide-white-horizontal.png",
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nationwide-marketing-image__container" }, [
          _c(
            "div",
            {
              staticClass:
                "nationwide-marketing-image__container--inner hidden-l flex",
              staticStyle: { width: "100%", "justify-content": "flex-end" },
            },
            [
              _c("img", {
                staticClass: "nationwide-marketing-image",
                attrs: {
                  src: "https://images.ctfassets.net/bx9krvy0u3sx/3AaDHCJWMPUCEs49yZb67A/ccb7c02c9c6c9cfd82cacd4a43158d07/ESC-0283AO_Email_CLAuto_September_Insured_IMAGEONLY.jpg",
                  alt: "",
                },
              }),
            ]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col xs-12 lg-6" }, [
      _c("h5", [_vm._v("LIMITED TIME OFFER")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "As a valued Nationwide customer, you’ve been selected for an exclusive offer – protect your rig with best-in-class dashcam technology for FREE."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We’ll send you a high-definition dash camera with embedded artificial intelligence ($350 value) + two years of monthly service ($1,228 value) PLUS special renewal pricing*."
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h5", [_vm._v("Equipment Highlights")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("Simple, self-installation in less than 15 minutes")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Front-facing camera with auto-upload of all incident footage"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Real-time GPS fleet tracking and vehicle diagnostics"),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Mobile Driver App with ELD data, routing & messaging"),
        ]),
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v("Benefits of telematics")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Video footage helps protect you against false claims and legal battles"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Fulfill your ELD requirement and improve fuel efficiency"),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Helps us develop future programs at best possible rates"),
        ]),
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v("Protect your rig in three simple steps")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "Fill out the form on your right, review the terms & conditions, and submit."
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Wait for dashcam equipment to be delivered to your door within six business days."
          ),
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Plug in the new dashcam and get started!")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "sneaky-text space-top-2" }, [
        _vm._v(
          "\n                        * Based on meeting program KPIs and eligibility for renewal based on underwriting guidelines.\n                    "
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("For a live look, watch this video footage")]),
      _vm._v(" "),
      _c("div", { staticClass: "hidden-l" }, [
        _c("iframe", {
          attrs: {
            width: "460",
            height: "280",
            src: "https://www.youtube.com/embed/G-D1FIXHdVQ",
            frameborder: "0",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex start-xs mobile-column full-width" },
      [
        _c("h5", { staticClass: "space-top-0" }, [
          _vm._v("Customer Information"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex", attrs: { for: "firstname" } }, [
      _vm._v("First Name"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex", attrs: { for: "lastname" } }, [
      _vm._v("Last Name"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex", attrs: { for: "email" } }, [
      _vm._v("Email"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex", attrs: { for: "company" } }, [
      _vm._v("Company"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex", attrs: { for: "phone" } }, [
      _vm._v("Phone"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex", attrs: { for: "dotNumber" } }, [
      _vm._v("DOT #"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex", attrs: { for: "street" } }, [
      _vm._v("Street"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex", attrs: { for: "city" } }, [
      _vm._v("City"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex", attrs: { for: "state" } }, [
      _vm._v("State"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex", attrs: { for: "zip" } }, [
      _vm._v("ZIP"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex start-xs full-width" }, [
      _c("p", { staticClass: "sneaky-text" }, [
        _vm._v("* PO Boxes not eligble"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "flex" }, [
      _vm._v("Vehicle Identification Numbers"),
      _c("div", { staticClass: "required" }, [_vm._v(" *")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "space-bottom-1" }, [
      _c("label", [
        _vm._v("By clicking “Submit,” I acknowledge the receipt of the "),
        _c("a", { attrs: { href: "/support/privacy", target: "_blank" } }, [
          _vm._v("Privacy Policy"),
        ]),
        _vm._v(" and that I have reviewed the "),
        _c(
          "a",
          {
            attrs: {
              href: "https://assets.ctfassets.net/bx9krvy0u3sx/6CU2WdeDbUVHDX33Bhgnf2/5d38fc20d019e41462d11a6784dcaf88/Terms_and_Conditions_of_the_Nationwide_Samsara_Exclusive_Offer_2.10__1_.docx",
            },
          },
          [_vm._v("terms and conditions")]
        ),
        _vm._v(" with Nationwide."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container--form space-top-2" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col sm-12 center-text" }, [
          _c("h1", [_vm._v("You are all set!")]),
          _vm._v(" "),
          _c("h3", [
            _vm._v(
              "Thank you for participating in Nationwide’s E&S Non-Fleet Safety Pilot"
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Approvals will take 1-3 business days. Once approved, Samsara will send out shipping details and “Getting Started” documentation. "
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If you have questions regarding your Samsara equipment/dashboard, please contact support@samsara.com  "
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If you have questions regarding your Nationwide policy, please contact your General Agent or reach out to telelmatics@nationwide.com "
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }